export const extractFileFormat = jsonLd => {
  return jsonLd['schema:fileFormat'];
};